import { FeatureGating, ReRouteBackButton, GameControllerSupport, OnDeviceCache, IsScrollEnabled, PaywallDismissal, PresentationCondition, ShowPaywallOption } from "@prisma/client";
import * as Factory from "factory";
import * as faker from "faker";
import { PaywallPresentationStyle } from "../db";
// https://spin.atomicobject.com/2017/03/15/typescript-generate-test-data/
export const paywallFacotry = Factory.Sync.makeFactoryWithRequired({
    id: Factory.each((i)=>i),
    name: Factory.each(()=>faker.name.firstName()),
    slug: Factory.each(()=>faker.lorem.slug()),
    sourcePaywallId: null,
    v4: false,
    deployedPaywallVersionId: null,
    featureGating: FeatureGating.NON_GATED,
    reRouteBackButton: ReRouteBackButton.DISABLED,
    gameControllerSupport: GameControllerSupport.DISABLED,
    onDeviceCache: OnDeviceCache.ENABLED,
    isScrollEnabled: IsScrollEnabled.ENABLED,
    inSuperwallWebflowAccount: false,
    migratedAt: null,
    localNotifications: [],
    url: "https://www.fitnessai.com/paywall-no-video-2",
    requiredLocalizations: [
        "347+ detailed exercise guides ",
        "40% OFF",
        "7 days free then only $89.99 per yr ",
        "7 days free, cancel anytime ",
        "Adapted to your strength ",
        "How your 7-day FREE trial works {}",
        "In 6 days  ⏰",
        "Just $1.73 per week",
        "Life changing advice ",
        "Only $1.73 per week billed annually. That's 50-100x cheaper than a trainer. ",
        "Optimized workouts everyday ",
        "Over 1,000,000 happy users ",
        "START 7-DAY FREE TRIAL",
        "So how does my free trial work?",
        "We'll remind you 24 hrs before charging your card. ",
        "World renowned coaches "
    ],
    substitutions: {
        substitutions: [
            {
                key: "title",
                value: "How your 7-day FREE trial works {{primary.price}}"
            },
            {
                key: "subtitle",
                value: "Only $1.73 per week billed annually. That's 50-100x cheaper than a trainer. "
            },
            {
                key: "bullet-1",
                value: "Optimized workouts everyday "
            },
            {
                key: "bullet-2",
                value: "Adapted to your strength "
            },
            {
                key: "bullet-3",
                value: "347+ detailed exercise guides "
            },
            {
                key: "bullet-4",
                value: "World renowned coaches "
            },
            {
                key: "bullet-5",
                value: "Life changing advice "
            },
            {
                key: "bullet-6",
                value: "Over 1,000,000 happy users "
            },
            {
                key: "timeline title",
                value: "So how does my free trial work?"
            },
            {
                key: "Timeline Row 3 Title",
                value: "In 6 days  ⏰"
            },
            {
                key: "Timeline Row 3 Subtitle",
                value: "We'll remind you 24 hrs before charging your card. "
            },
            {
                key: "callout-badge",
                value: "40% OFF"
            },
            {
                key: "callout title",
                value: "Just $1.73 per week"
            },
            {
                key: "callout subtitle",
                value: "7 days free, cancel anytime "
            },
            {
                key: "purchase button subtitle",
                value: "7 days free then only $89.99 per yr "
            },
            {
                key: "purchase-primary",
                value: "START 7-DAY FREE TRIAL"
            }
        ]
    },
    primaryProductIdentifier: "com.fitnessai.annual_39.99_7",
    secondaryProductIdentifier: null,
    tertiaryProductIdentifier: null,
    presentationStyle: PaywallPresentationStyle.FULLSCREEN,
    showPaywallOption: ShowPaywallOption.EXPLICIT,
    paywallDismissal: PaywallDismissal.NORMAL,
    presentationCondition: PresentationCondition.CHECK_USER_SUBSCRIPTION,
    // backgroundColorHex: Factory.each(() => "#" + faker.datatype.hexaDecimal(6)),
    backgroundColorHex: "#FFFFFF",
    enabled: true,
    createdAt: Factory.Sync.each(()=>new Date()),
    updatedAt: Factory.Sync.each(()=>new Date()),
    archivedAt: null,
    pageStyles: [],
    templateJson: {},
    // manifest: Prisma.DbNull,
    // products: Prisma.DbNull,
    templateType: null,
    templateId: null,
    ignoredLocalizations: [],
    darkBackgroundColorHex: null,
    surveyId: null
});
export const paywallWithoutIds = ({ ...args } = {})=>{
    const { applicationId, id, ...paywall } = paywallFacotry.build({
        applicationId: 1,
        ...args
    });
    return paywall;
};
// These functions are for swapping paywall ids in dev to map them to clickhouse ids.
// They hot swap of a paywall's id to the top fitnessAI production ids.
// We use this to match the clickhouse
// paywall_id      Impressions
//     10       |    16374
//     6	      |    4678
//     11       |    2019
//     26       |    155
//     24       |    49
// export const paywallIdSwapARooski = (paywall: Paywall, id: number = 0): Paywall => {
//   return { ...paywall, id: [10, 6, 11, 26, 24][id]! }
// }
export const paywallsIdSwapARooski = (paywalls)=>{
    // paywall_id      Impressions
    //     10       |    16374
    //     6	      |    4678
    //     11       |    2019
    //     26       |    155
    //     24       |    49
    const fitnessAITestIds = [
        10,
        6,
        11,
        26,
        24
    ].splice(0, paywalls.length);
    const newPaywalls = fitnessAITestIds.map((id, i)=>({
            ...paywalls[i],
            id
        }));
    return newPaywalls.concat(paywalls.splice(newPaywalls.length));
};
